import React, { useEffect, useRef } from 'react';
import { View, Text, StyleSheet, Dimensions, Animated } from 'react-native';
import { LIST_SUB_TEXT } from '../../style';
import { ImageComp } from '../Image/Image';
import { INFO_CIRCLE, DIRECTIVE_ARROW_1, DIRECTIVE_ARROW_2, DIRECTIVE_ARROW_3, FRONT_ICON, LEFT_ICON, RIGHT_ICON, FACE_OVERLAY_FRONT, FACE_SCANNING, FACE_SCANNING_SUCCESS, FACE_OVERLAY, FACE_OVERLAY_LEFT, FACE_OVERLAY_RIGHT } from '../../assets';
import { useCssStyle } from '../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import LottieView from 'lottie-react-native';
import { isWeb } from '../../utils/Helper';
import triggerHapticFeedback from '../../js/vibration';
import { Chip } from '../chip';

const { width, height } = Dimensions.get('window');

const SelfieOverlay = ({ tipIndex, startAnimation }) => {

  const getStyle = useCssStyle();
  const { t } = useTranslation();

  const textOpacity = useRef(new Animated.Value(1)).current;

  const scaleValue = useRef(new Animated.Value(1)).current;
  const shimmerTranslateX = useRef(new Animated.Value(-width * 0.75)).current;


  const startPulsing = () => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(scaleValue, {
          toValue: 1.05,
          duration: 800,
          useNativeDriver: true,
        }),
        Animated.timing(scaleValue, {
          toValue: 1,
          duration: 800,
          useNativeDriver: true,
        }),
      ])
    ).start();
  };

  const startShimmer = () => {
    Animated.loop(
      Animated.timing(shimmerTranslateX, {
        toValue: width * 0.75,
        duration: 1500,
        useNativeDriver: true,
      })
    ).start();
  };

  useEffect(() => {


    if (startAnimation) {
      startPulsing();
      startShimmer();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startAnimation]);


  useEffect(() => {
    if(tipIndex == 10) {
      triggerHapticFeedback('effectTick');
    }
  },[tipIndex])

  return (
    <View style={getStyle(['selfieTipOverlay'])} id='selfieTipOverlay'>
      {/* <Animated.View style={[styles.ovalFrame, { transform: [{ scale: scaleValue }] }]} id={"ovalFrame"}>

        <Animated.View
          style={[
            styles.shimmer,
            {
              transform: [{ translateX: shimmerTranslateX }],
            },
          ]}
        />
      </Animated.View> */}

      {/* <ImageComp
        source={
          tipIndex == 0 ? DIRECTIVE_ARROW_1
            : tipIndex == 1 ? DIRECTIVE_ARROW_2
              : tipIndex == 2 ? DIRECTIVE_ARROW_3
                : null
        }
        style={getStyle([{width: tipIndex == 0 ? 6 : width * 0.75, height: height * 0.5, top: height * 0.06,}, 'selfieTipOverlayArrows', tipIndex == 0 ? 'selfieFront' : tipIndex == 1 ? 'selfieLeft' : tipIndex == 2 ? 'selfieRight' : ""])} id='selfieTipOverlayArrows' /> */}

      {/* <View style={getStyle(['selfieTipTextContainer'])} id='selfieTipTextContainer'>
        <ImageComp style={getStyle(['selfieTipIcon'])} source={
          tipIndex == 0 ? FRONT_ICON
            : tipIndex == 1 ? LEFT_ICON
              : tipIndex == 2 ? RIGHT_ICON
                : null
        } id='selfieTipIcon' />
        <Text style={getStyle(['selfieTipText'])} id='selfieTipText' >{
          tipIndex == 0 ? "Look straight"
            : tipIndex == 1 ? "Rotate your head slightly to the left"
              : tipIndex == 2 ? "Rotate your head slightly to the right"
                : null
        }</Text>
      </View> */}

      {/* <View style={getStyle(['instructionContainer'])} id='instructionContainer'>
        <ImageComp source={INFO_CIRCLE} style={getStyle(['infoIcon'])} id='infoIcon'/>
        <Text style={getStyle(['instructionText'])} id='instructionText'>
          Remove any objects that obscure your identity like glasses, hats, or masks.
        </Text>
      </View> */}


      <ImageComp
        source={FACE_OVERLAY}
        style={getStyle(['selfieTipOverlayBG'])}
        id='selfieTipOverlayBG' 
      />

      {startAnimation &&

      (tipIndex == 10 ?

        <LottieView
          source={FACE_SCANNING_SUCCESS}
          style={getStyle(['selfieTipOverlayImage'])}
          autoPlay={true}
          loop={true}
        />

        :
        <>
          <LottieView
            source={FACE_SCANNING}
            style={getStyle(['selfieTipOverlayImage'])}
            autoPlay={true}
            loop={true}
          />

          <LottieView
            source={tipIndex == 1 ? FACE_OVERLAY_LEFT : tipIndex == 2 ? FACE_OVERLAY_RIGHT : tipIndex == 3 ? FACE_OVERLAY_FRONT : null}
            style={getStyle(['selfieTipOverlayImage'])}
            autoPlay={true}
            loop={true}
          />
        </>
        )
      }

      
      <Chip
        startPulsating={startAnimation}
        text={
          tipIndex == 0 ? "Start scan when ready"
              : tipIndex == 1 ? "<< Slight left turn"
                : tipIndex == 2 ? "Slight right turn >>"
                  : tipIndex == 3 ? "Face Forward"
                    : tipIndex == 10 ? "Awesome!"
                      : null
        }
        style={getStyle(['selfieTipTextContainer'])}
      />

    </View>
  );
};

const styles = StyleSheet.create({
  ovalFrame: {
    position: 'absolute',
    width: width * 0.75,
    height: height * 0.5,
    borderWidth: 4,
    borderColor: 'white',
    borderRadius: width * 0.75 / 2,
    alignSelf: 'center',
    top: height * 0.06,
    overflow: 'hidden',
    maxWidth: "80%"
  },
  shimmer: {
    position: 'absolute',
    width: '40%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    borderRadius: width * 0.75 / 2,
    opacity: 0.7,
  }
});

export default SelfieOverlay;